import * as Yup from "yup";

interface CreditorPortalNote extends Yup.MixedSchema {
  note: string;
  noteCategoryId: number;
}

export default () => {
  return Yup.object<CreditorPortalNote>().shape({
    noteCategoryId: Yup.number().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
    note: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
  });
};
